import {
  Button,
  Heading,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@alefeducation/ui-elements-library-core';
import { Times, TrashSolid } from '@alefeducation/ui-elements-library-icons';
import React from 'react';
import styled from 'styled-components';
import { StyledModal } from '../../AvatarUploadModal/AvatarUploadModal.styled';
import { DELETE } from '../../../utils/constants';
import { useAvatarUploadContext } from '../context';

interface Props {
  title: string;
  description: string;
  isOpen: boolean;
  onClose: () => void;
}

export const AvatarDeleteModal = ({
  title,
  description,
  isOpen,
  onClose,
}: Props) => {
  const {
    deleteModal: { onDelete, loading },
  } = useAvatarUploadContext();

  return (
    <StyledModal
      size="small"
      handleBackdropClick={() => {}}
      data-testid="delete-avatars-modal"
      open={isOpen}
    >
      <ModalHeader>
        <Times
          role="icon"
          aria-label="cross"
          color="primary.40"
          height="14"
          width="14"
          cursor="pointer"
          onClick={onClose}
        />
      </ModalHeader>
      <ModalContent>
        <StyledBodyContent>
          <ExclamationIcon />
          <StyledTitle>
            <Heading variant="heading-small" weight="bold" color="text.100">
              {title}
            </Heading>
          </StyledTitle>
          <Heading variant="heading-small" weight="light" color="text100">
            {description}
          </Heading>
        </StyledBodyContent>
      </ModalContent>
      <ModalActions>
        <Button
          variant="secondary"
          onClick={() => {
            onClose();
          }}
          data-testid={'avatar-delete-cancel-button'}
        >
          Cancel
        </Button>
        <Button
          onClick={onDelete}
          disabled={loading}
          data-testid={'avatar-delete-button'}
          icon={<TrashSolid />}
        >
          {DELETE}
        </Button>
      </ModalActions>
    </StyledModal>
  );
};

const ExclamationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60 30C60 46.5722 46.5674 60 30 60C13.4326 60 0 46.5722 0 30C0 13.4375 13.4326 0 30 0C46.5674 0 60 13.4375 60 30ZM30 36.0484C26.9268 36.0484 24.4355 38.5397 24.4355 41.6129C24.4355 44.6861 26.9268 47.1774 30 47.1774C33.0732 47.1774 35.5645 44.6861 35.5645 41.6129C35.5645 38.5397 33.0732 36.0484 30 36.0484ZM25.6143 32.4985L24.717 16.0469C24.6716 15.2153 25.3335 14.5161 26.1663 14.5161H33.8336C34.6663 14.5161 35.3284 15.2153 35.283 16.0469L34.3857 32.4985C34.3437 33.2683 33.7072 33.871 32.9362 33.871H27.0637C26.2928 33.871 25.6563 33.2683 25.6143 32.4985Z"
      fill="#FFD229"
    />
  </svg>
);

const StyledBodyContent = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
  text-align: center;

  svg {
    margin-bottom: 24px;
  }
`;

const StyledTitle = styled.span`
  margin-bottom: 16px;
`;
